export class EmailAnalyticsDetailRow {
	public id: string;
	public groupName: string;
	public numEmailTypes: number;
	public detailType: string;
	public name: string;
	public openRate: number;
	public clickRate: number;
	public unsubscribeRate: number;
	public signRate: number;
	public totalOpenCount: number;
	public totalClickCount: number;

	constructor(emailAnalyticsDetailRow?: EmailAnalyticsDetailRow) {
		Object.assign(this, emailAnalyticsDetailRow);
	}
}
